import type { ErrorType } from '~/data/ErrorRecord';
import { getLastReadChangeLogItemDate } from '~/utils/local-storage-utils/local-storage-utils';

export const defaultState: Fields = {
  isLoading: false,
  isModalOpen: false,
  items: [],
  lastReadChangeLogItemDate: getLastReadChangeLogItemDate(''),
  error: undefined,
};

export interface Fields {
  isLoading: boolean;
  isModalOpen: boolean;
  items: ChangeLogItem[];
  lastReadChangeLogItemDate: string;
  error?: ErrorType;
}

export interface ChangeLogItem {
  id: string;
  date: string;
  title: string;
  content: string[];
  images: string[];
}
